export const getDepartamento = (numAmb, nomenclator, eleccion) => {
  let idAmb,
    idPadre,
    idAbu = '';
  if (numAmb.length < 3) return numAmb;
  else {
    idAmb = nomenclator.ambitos[eleccion].find(e => e.c === numAmb).i;
    idPadre = nomenclator.ambitos[eleccion][idAmb].p[0];
    if (numAmb.length < 6) return nomenclator.ambitos[eleccion][idPadre].c;
    else {
      idAbu = nomenclator.ambitos[eleccion][idPadre].p[0];
      return nomenclator.ambitos[eleccion][idAbu].c;
    }
  }
};

export const getDept = (numAmb, citrep) => {
  let nDep = numAmb;
  if (citrep) {
    nDep = numAmb.length > 2 ? numAmb.slice(2) : numAmb;
  } else {
    nDep = numAmb.slice(0, 2);
  }
  return nDep;
};
